// extracted by mini-css-extract-plugin
export var header = "lasik-module--header--BUM03";
export var laser = "lasik-module--laser--nNnv2";
export var laserWrapper = "lasik-module--laserWrapper--TGu7R";
export var lasikGrid = "lasik-module--lasikGrid--tcL-t";
export var paragraph = "lasik-module--paragraph--XFdxu";
export var paragraphWrapper = "lasik-module--paragraphWrapper--jgO-G";
export var wrapper = "lasik-module--wrapper--xAJ2p";